import { useEffect, useRef, useState } from "react";
import { Header } from "../../widgets";
import { Loader } from "../../widgets/loaders/Loader";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-input-2'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import useFormPersist from 'react-hook-form-persist'
import { classNames } from "primereact/utils";
import { getItemLocalStorage } from "../../features/webStorageSaver";
import ToastMessageContainer from "../../widgets/toastMessageContainer/ToastMessageContainer";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../stateManagement/reducers";

const eyeIcon = require('../../assets/images/fontAwesomeIcons/eye-solid.svg').default
const eyeSlashIcon = require('../../assets/images/fontAwesomeIcons/eye-slash-solid.svg').default

// Страница для восстановления пароля
export function RegisterPage() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [databaseOptions, setDataBaseOptions] = useState<any>();

    const validationSchema = yup.object().shape({
        database: yup.string().required("Выберите базу данных."),
        userName: yup.string().required("Введите логин.").min(6, "Длина логина должна быть 6 символов и более").matches(/^[A-z\d\._]+$/ig, "Логин может содержать только наборы символов: <A-z> <0-9> <.> <_>"),
        password: yup.string().required("Введите пароль.").min(8, "Длина пароля должна быть 8 символов и более").matches(/^[A-z\d\._]+$/ig, "Пароль может содержать только наборы символов: <A-z> <0-9> <.> <_>"),
        firstName: yup.string().required("Введите имя."),
        secondName: yup.string().required("Введите фамилию."),
        patronymicName: yup.string(),
        orgName: yup.string().required("Введите полное наименование организации.").matches(/^[А-ЯA-Z]+[\s]?([«"А-яA-z\s-—&\.!,?"»]+)$/g, "Название компании может содержать только наборы символов: <A-z> <А-я> <.> <,> <-> <−> <—> <?> <!> и пробел. Должно начинаться с большой буквы."),
        departmentName: yup.string().required("Введите департамент (отдел).").matches(/^[«"А-яA-z\s-—&\.,"»]+$/g, "Название отдела может содержать только наборы символов: <A-z> <А-я> <0-9> <.> <,> <-> <−> <—> и пробел."),
        position: yup.string().required("Введите должность.").matches(/^[А-я\s-\.]+$/g, "Название должности может содержать только наборы символов: <А-я> <0-9> <.> <,> <-> <−> <—> и пробел."),
        email: yup.string().required("Введите email.").matches(/^\w+([\._-]?\w+)*@\w+([\._-]?\w+)*(\.\w{2,3})+$/ig, "Неверный email адрес"),
        telephone: yup.string().required("Введите номер телефона.").matches(/(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/, "Номер телефона должен соответствовать виду: +7 (xxx) xxx xxxx"),
        check: yup.string(),
    });
    // определения из библиотеки react-hook-form
    const {
        register,
        handleSubmit,
        reset,
        control,
        watch,
        setValue,
        formState: {
            errors,
            isSubmitting,
        }
    }: any = useForm({
        // начальные значения для формы
        defaultValues: {
            "database": sessionStorage.getItem('geo3.registerDataBase') ?? "",
            "userName": "",
            "password": "",
            "firstName": "",
            "secondName": "",
            "patronymicName": "",
            "orgName": "",
            "departmentName": "",
            "position": "",
            "email": "",
            "telephone": "",
            "check": ""
        },
        mode: 'onTouched',
        resolver: yupResolver(validationSchema),
    });

    const dataBase = watch('database');
    const [passwordIsShown, setPasswordIsShown] = useState<boolean>(false)

    function passwordEyeClick() {
        setPasswordIsShown(!passwordIsShown)
    }

    useEffect(() => {
        const fullConfig = getItemLocalStorage("fullConfig")
        let dataBases: any = []
        Object.keys(fullConfig).map((key: any) => {
            if (fullConfig[key].selectable && fullConfig[key]?.allowRegistration) {
                dataBases.push({ prefix: key, name: fullConfig[key].company })
            }
        })
        dataBases.sort((a, b) => a?.name.localeCompare(b?.name))
        setDataBaseOptions(dataBases)
        reset()
    }, [])

    const errRef = useRef<HTMLInputElement>()
    const [loading, setLoading] = useState<any>();
    const [isSuccess, setIsSuccess] = useState<boolean>(false)

    useFormPersist("registerForm", {
        watch,
        setValue,
        exclude: ['database', 'userName', 'password']
    });

    useEffect(() => {
        sessionStorage.setItem('geo3.registerDataBase', dataBase)
    }, [dataBase])

    // обработчик для кнопки "Вход"
    async function onSubmit(data: {
        database: string,
        userName: string,
        password: string,
        firstName: string,
        secondName: string,
        patronymicName: string,
        orgName: string,
        departmentName: string,
        position: string,
        email: string,
        telephone: string,
        check: string
    }) {
        setLoading(true)
        const fullConfig = getItemLocalStorage("fullConfig")
        const currentConfig = fullConfig[data.database]
        let apiUrl = currentConfig?.irosRestApiUrl
        let userName = data.userName
        let password = data.password
        let firstName = data.firstName
        let secondName = data.secondName
        let patronymicName = data.patronymicName
        let orgName = data.orgName
        let departmentName = data.departmentName
        let position = data.position
        let email = data.email
        let telephone = '+7(111)111-11-11'
        let check = data.check
        try {
            const url = `${apiUrl}/security/account/signUp`
                + `?UserName='${userName}'`
                + `&Password='${password}'`
                + `&FirstName='${firstName}'`
                + `&SecondName='${secondName}'`
                + (patronymicName ? `&PatronymicName='${patronymicName}'` : '')
                + `&OrgName='${orgName}'`
                + `&DepartmentName='${departmentName}'`
                + `&Position='${position}'`
                + `&Email='${email}'`
                + `&Telephone='${telephone}'`;
            let response: any
            if (!check) {
                response = await axios.get(url);
            }
            const data = response.data;
            if (data?.NewUserId) {
                setIsSuccess(true)
            }
            if (data?.Error === 'Email already exists') {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Такой адрес электронной почты уже зарегистрирован в базе.', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            if (data?.Error === 'User already exists') {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Такой пользователь уже существует, пожалуйста, придумайте другой логин.', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            setLoading(false)
        } catch (error: any) {
            if (error?.response?.status === 502) {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Ошибка сервера', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            if (error?.response?.status !== 502 && error?.response?.data?.error?.code !== 'Forbidden') {
                // отображение контейнера уведомления об ошибке
                dispatch(showToastMessage({ messageText: 'Проблемы с соединением', messageType: "error" }))
                if (errRef.current)
                    errRef.current.focus();
            }
            setIsSuccess(false)
            setLoading(false)
        }
    }

    let loginWindowClassName = classNames({
        "login-window": true,
        "register-window": isSuccess
    })

    let passwordIconClassName = classNames({
        "eye-password": passwordIsShown,
        "slash-eye-password": !passwordIsShown
    })
    return (
        <>
            {loading ? <Loader /> : <></>}
            <div className="h-100">
                <ToastMessageContainer position="bottom-center" />
                <Header type="login" />
                <div className="login-page-back register-page-back">
                    <>
                        <div className={loginWindowClassName}>
                            <div className="login-window-top register-top">
                                {isSuccess ? 'Подтверждение регистрации' : 'Регистрация'}
                            </div>
                            <div className="login-window-main register-window-main">
                                {window.innerWidth < 767 &&
                                    <span className="asterisk-text">* поле обязательно для заполнения</span>
                                }
                                {!isSuccess
                                    ?
                                    <form onSubmit={handleSubmit(onSubmit)} id="register-form">
                                        <div className="database-fieldset custom-field">
                                            <h1>
                                                <span>
                                                    База данных
                                                </span>
                                            </h1>
                                            <label className="d-flex flex-column">
                                                <span className="required">Выберите базу данных для регистрации</span>
                                                {/* Поле выбора базы данных */}
                                                <select
                                                    {...register("database", {
                                                        required: "Выберите базу данных.",
                                                    })}
                                                    aria-invalid={errors["database"]}
                                                >
                                                    <option disabled value="">Выберите базу данных...</option>
                                                    {databaseOptions && databaseOptions.map((db: any) => {
                                                        if (getItemLocalStorage("remindPasswordBase") === db.prefix) {
                                                            return <option value={db.prefix} key={db.prefix} selected>{db.name}</option>
                                                        } else {
                                                            return <option value={db.prefix} key={db.prefix} >{db.name}</option>
                                                        }
                                                    })}
                                                </select>
                                                {errors["database"] &&
                                                    <p role="alert">{errors["database"]?.message}</p>}
                                            </label>
                                        </div>
                                        <div className="fieldset-block-hor d-flex">
                                            <div className="fieldset-block-ver first-fie">
                                                <div className="custom-field ">
                                                    <h1>
                                                        <span>
                                                            Контактная информация
                                                        </span>
                                                    </h1>
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Фамилия</span>
                                                        {/* Поле для ввода фамилии */}
                                                        <input
                                                            {...register("secondName")}
                                                            aria-invalid={errors["secondName"]}
                                                            placeholder="Введите фамилию..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["secondName"] && <p role="alert">{errors["secondName"]?.message}</p>}
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Имя</span>
                                                        {/* Поле для ввода имени */}
                                                        <input
                                                            {...register("firstName")}
                                                            aria-invalid={errors["firstName"]}
                                                            placeholder="Введите имя..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["firstName"] && <p role="alert">{errors["firstName"]?.message}</p>}
                                                    <label className="d-flex flex-column">
                                                        <span>Отчество</span>
                                                        {/* Поле для ввода отчества */}
                                                        <input
                                                            {...register("patronymicName")}
                                                            aria-invalid={errors["patronymicName"]}
                                                            placeholder="Введите отчество..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["patronymicName"] && <p role="alert">{errors["patronymicName"]?.message}</p>}
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Email</span>
                                                        {/* Поле для ввода email */}
                                                        <input
                                                            {...register("email")}
                                                            aria-invalid={errors["email"]}
                                                            placeholder="Введите email..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["email"] && <p role="alert">{errors["email"]?.message}</p>}
                                                    <label className="d-flex flex-column">
                                                        {/* Поле для ввода номера телефона */}
                                                        <Controller
                                                            name="telephone"
                                                            control={control}
                                                            defaultValue=""
                                                            render={({ field: { onChange, value } }) => (
                                                                <PhoneInput
                                                                    country="ru"
                                                                    value={value}
                                                                    onChange={onChange}
                                                                    placeholder="Введите номер телефона..."
                                                                    specialLabel="Телефон"
                                                                    autoFormat
                                                                />
                                                            )}
                                                        />
                                                    </label>
                                                    {errors["telephone"] && <p role="alert">{errors["telephone"]?.message}</p>}
                                                    <label className="d-flex flex-column check-input">
                                                        <span className="required">Check</span>
                                                        {/* Поле для ввода Check */}
                                                        <input
                                                            {...register("check")}
                                                            aria-invalid={errors["check"]}
                                                            placeholder="Введите Check..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["check"] && <p role="alert">{errors["check"]?.message}</p>}
                                                </div>
                                                {window.innerWidth > 766 &&
                                                    <span className="asterisk-text">* поле обязательно для заполнения</span>
                                                }
                                            </div>
                                            <div className="fieldset-block-ver">
                                                <div className="workplace-fieldset custom-field">
                                                    <h1>
                                                        <span>
                                                            Место работы
                                                        </span>
                                                    </h1>
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Полное наименование организации</span>
                                                        {/* Поле для ввода названия организации */}
                                                        <input
                                                            {...register("orgName")}
                                                            aria-invalid={errors["orgName"]}
                                                            placeholder="Введите полное наименование организации..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["orgName"] && <p role="alert">{errors["orgName"]?.message}</p>}
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Департамент (отдел)</span>
                                                        {/* Поле для ввода департамента (отдела) */}
                                                        <input
                                                            {...register("departmentName")}
                                                            aria-invalid={errors["departmentName"]}
                                                            placeholder="Введите департамент (отдел)..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["departmentName"] && <p role="alert">{errors["departmentName"]?.message}</p>}
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Должность</span>
                                                        {/* Поле для ввода должности */}
                                                        <input
                                                            {...register("position")}
                                                            aria-invalid={errors["position"]}
                                                            placeholder="Введите должность..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["position"] && <p role="alert">{errors["position"]?.message}</p>}
                                                </div>
                                                <div className="custom-field">
                                                    <h1>
                                                        <span>
                                                            Данные для входа
                                                        </span>
                                                    </h1>
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Логин</span>
                                                        {/* Поле для ввода логина */}
                                                        <input
                                                            {...register("userName")}
                                                            aria-invalid={errors["userName"]}
                                                            placeholder="Введите логин..."
                                                            type="text"
                                                        />
                                                    </label>
                                                    {errors["userName"] && <p role="alert">{errors["userName"]?.message}</p>}
                                                    <label className="d-flex flex-column">
                                                        <span className="required">Пароль</span>
                                                        {/* Поле для ввода пароля */}
                                                        <div className="d-flex">
                                                            <input
                                                                {...register("password")}
                                                                className="new-password-input"
                                                                aria-invalid={errors["password"]}
                                                                placeholder="Введите пароль..."
                                                                type={passwordIsShown ? "text" : "password"}
                                                            />
                                                            <div onClick={passwordEyeClick} className="password-eye-button">
                                                                <img className={passwordIconClassName} src={passwordIsShown ? eyeIcon : eyeSlashIcon} />
                                                            </div>
                                                        </div>
                                                    </label>
                                                    {errors["password"] && <p role="alert">{errors["password"]?.message}</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <button disabled={isSubmitting}>Зарегистрироваться</button>
                                    </form>
                                    :
                                    <div>
                                        <span className="success-message">В ближайшее время вам придет письмо со ссылкой для подтверждения регистрации.</span>
                                        <button onClick={() => navigate('/')} className="back-to-main-but">На главную</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </>
    );
}
